var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9292 3.85023C24.3042 8.22523 24.3042 15.2252 19.9875 19.5419L12.1125 27.4169L4.2375 19.5419C-0.0791666 15.2252 -0.0791666 8.22523 4.2375 3.90857L4.29583 3.85023C8.6125 -0.466435 15.5542 -0.524768 19.9292 3.85023ZM19.9292 3.85023C19.8708 3.7919 19.8708 3.7919 19.9292 3.85023Z",
    stroke: "#658479",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1133 16C14.3224 16 16.1133 14.2091 16.1133 12C16.1133 9.79086 14.3224 8 12.1133 8C9.90414 8 8.11328 9.79086 8.11328 12C8.11328 14.2091 9.90414 16 12.1133 16Z",
    stroke: "#658479",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/Map_pin.85d0ce30e113da83bc2ef46ca7fe17df.svg";
export { ForwardRef as ReactComponent };